<template>
  <v-container justify-center fluid grid-list-xl>
    <v-layout justify-center wrap>
      <messageBox ref="msgBox" />

      <AssistantEditor
        v-model="assistantEditorDialog"
        :assistant="selectedAssistant"
        @onSave="onAssistantSave"
      />

      <OperatorTestDialog
        v-model="operatorTestDialog"
        :assistant="selectedOperatorForTest"
      />

      <v-flex md12>
        <v-card class="ma-1">
          <v-toolbar color="#0044a3" dark>
            <v-app-bar-nav-icon><v-icon large>mdi-account-multiple</v-icon></v-app-bar-nav-icon>
            <v-toolbar-title class="white--text">{{
              $t("automazione-operators")
            }}</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-btn color="white" outlined @click="openAssistantEditor()">
              <v-icon left>mdi-plus</v-icon>{{ $t("automazione-add-operator") }}
            </v-btn>
          </v-toolbar>

          <v-card-text>
            <v-data-table
              :items="assistants"
              :headers="assistantHeaders"
              dense
              :loading="loadingSetup"
              item-key="id"
              :items-per-page="10"
            >
              <template v-slot:item.instructions="{ item }">
                <span>{{ item.instructions ? item.instructions.substring(0, 100) : "" }}</span>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      x-small
                      text
                      icon
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      @click="openOperatorTest(item)"
                    >
                      <v-icon>mdi-message-text-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("automazione-test-open") }}</span>
                </v-tooltip>
                <v-btn x-small text icon color="orange" @click="openAssistantEditor(item)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn x-small text icon color="red" @click="removeAssistant(item)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import messageBox from "../../components/MessageBox";
import AssistantEditor from "../../components/automazione/AssistantEditor";
import OperatorTestDialog from "../../components/automazione/OperatorTestDialog";
import automazione from "../../apis/automazione";

export default {
  components: {
    messageBox,
    AssistantEditor,
    OperatorTestDialog
  },

  data() {
    return {
      loadingSetup: false,
      assistants: [],
      assistantEditorDialog: false,
      selectedAssistant: null,
      operatorTestDialog: false,
      selectedOperatorForTest: null,
      assistantHeaders: [
        { text: this.$t("automazione-operator-name"), value: "name", sortable: true },
        { text: this.$t("automazione-operator-provider"), value: "provider", sortable: true },
        { text: this.$t("automazione-operator-model"), value: "model", sortable: true },
        {
          text: this.$t("automazione-operator-temperature"),
          value: "temperature",
          sortable: true
        },
        { text: this.$t("automazione-operator-instructions"), value: "instructions", sortable: false },
        { text: "", value: "actions", sortable: false, align: "right" }
      ]
    };
  },

  mounted() {
    this.loadData();
  },

  methods: {
    async loadData() {
      this.loadingSetup = true;
      await this.fetchSetup();
      this.loadingSetup = false;
    },

    fetchSetup() {
      return automazione.fetchSetup().then(result => {
        this.assistants = result.assistants;
      });
    },

    openAssistantEditor(assistant) {
      this.selectedAssistant = assistant ? Object.assign({}, assistant) : null;
      this.assistantEditorDialog = true;
    },

    openOperatorTest(assistant) {
      this.selectedOperatorForTest = assistant
        ? Object.assign({}, assistant)
        : null;
      this.operatorTestDialog = true;
    },

    onAssistantSave(assistant) {
      automazione.saveAssistant(assistant).then(() => {
        this.assistantEditorDialog = false;
        this.fetchSetup();
      });
    },

    removeAssistant(assistant) {
      this.$refs.msgBox
        .show(
          this.$t("automazione-operator-delete-text"),
          this.$t("automazione-operator-delete-title"),
          true
        )
        .then(() => {
          automazione.removeAssistant(assistant.id).then(() => {
            this.fetchSetup();
          });
        })
        .catch(() => {});
    }
  }
};
</script>
